import type {FC} from 'react';
import clsx from 'clsx';

import type {MediaFragment} from '@/schema/primitives/media';

import {ImageFill} from '../image/ImageFill';
import {imageFromSanityImage} from '../image/query';

import type {MaskVariant} from './shared';
import {maskToAspectRatio, MEDIA_MASK_NONE} from './shared';

interface Props {
	image?: MediaFragment['image'];
	itemGalleryFirstMask?: MaskVariant;
	disabledMask?: boolean;
}

export const MediaImage: FC<Props> = ({
	image,
	itemGalleryFirstMask,
	disabledMask,
}) => {
	if (!image?.asset?._ref) {
		return null;
	}

	const mask =
		!disabledMask &&
		(itemGalleryFirstMask
			? itemGalleryFirstMask
			: 'mask' in image
				? image.mask
				: '');

	const hasMask = mask && mask !== MEDIA_MASK_NONE;
	const maskAspectRatio = maskToAspectRatio(mask || undefined);
	const sanityImage = imageFromSanityImage(image);

	if (!sanityImage) {
		return null;
	}

	return (
		<div
			className={clsx(
				'relative',
				'max-w-full',
				'max-h-full',
				mask,
				!hasMask && ['h-full', 'w-full', 'overflow-hidden'],
			)}
			style={{
				aspectRatio: hasMask
					? `${maskAspectRatio.width}/${maskAspectRatio.height}`
					: `${sanityImage.width}/${sanityImage.height}`,
			}}
		>
			<ImageFill
				{...sanityImage}
				alt={'altText' in image ? (image.altText ?? '') : ''}
			/>
		</div>
	);
};
